import React, { useEffect, useState } from 'react';
import './main.scss';
import CommonLayout from '../../components/Common/Layout/layout';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { CatalogData } from '../../data/catalog';
import Icon from '../../components/Common/Icon/icon';
import PrimaryButton from '../../components/Common/Button/primary-button';
import { useQuery } from '../../logic/hooks/useQuery';
import { CartData } from '../../data/cart-content';
import { Addittion } from '../../logic/const/constants';
import ProductCart from '../CatalogPage/components/ProductCart/product-cart';
import SaleProductCart from '../CatalogPage/components/SaleProductCart/product-cart';
import AdditionProductCart from '../CatalogPage/components/AdditionProductCart/product-cart';
import ModalOrderWindow from '../../components/Common/ModalWindow/modal';
import { Alert, Button, SliderThumb, Snackbar } from '@mui/material';
import { initializePrice } from '../../utils';

const DetailProduct = ({ cartData, setCartData }) => {
    const { id } = useParams();
    const query = useQuery();
    const navigate = useNavigate();
    const [product, setProduct] = useState(CatalogData.find(x => x.id == id))
    const [imageCount, setImageCount] = useState(0)
    const [textField, setTextField] = useState(0);
    const [selectedSize, setSelectedSize] = useState(0);

    const [modalOpen, setModalOpen] = useState(false);
    const [isShowNotification, setIsShowNotification] = useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    const showNotification = () => {
        setIsShowNotification(true);
    }

    const AddProductToCart = () => {
        let index = cartData.findIndex(x => x.id == id);
        showNotification();

        if (index != -1) {
            if (cartData[index].sizes == product.sizes[selectedSize]) {
                let newCart = [...cartData]
                newCart[index].count += 1;
                setCartData(newCart);
            } else {
                setCartData(cartData => [...cartData, { ...product, sizes: product.sizes[selectedSize], count: 1 }]);
            }
        } else {
            setCartData(cartData => [...cartData, { ...product, sizes: product.sizes[selectedSize], count: 1 }]);
        }
    }

    const AddAdditionProductToCart = (object) => {
        let index = cartData.findIndex(x => x.id == object.id);

        if (index != -1) {
            var newCart = [...cartData];
            newCart[index].count += 1
            setCartData(newCart)
        } else {
            setCartData(cartData => [...cartData, { ...object, count: 1 }]);
        }
        console.log(cartData)
    }

    const nextImage = () => {
        if (product.urlImg.length - 1 > imageCount) {
            setImageCount(imageCount + 1)
        } else {
            setImageCount(0)
        }
    }

    const previousImage = () => {
        if (imageCount != 0) {
            setImageCount(imageCount - 1)
        }
    }

    const renderSizes = () => {
        return product.sizes && product.sizes.map(x => {
            return <div class={`sizes-point ${selectedSize == product.sizes.indexOf(x) ? 'active' : ''}`} onClick={() => setSelectedSize(product.sizes.indexOf(x))}>{x}</div>
        })
    }

    const salesProduct = CatalogData.filter(x => x.id == "12" || x.id == "5" || x.id == "3").map(x => {
        return <><SaleProductCart id={x.id} urlImg={x.urlImg} price={x.price} code={x.code} sizes={x.sizes} stone={x.stone} addProductToCart={AddProductToCart} /></>
    })

    const salesAdditionProduct = CatalogData.filter(x => x.subCategory == Addittion).map(x => {
        return <><AdditionProductCart id={x.id} urlImg={x.urlImg} price={x.price} code={x.code} sizes={x.sizes} stone={x.stone} addProductToCart={AddAdditionProductToCart} /></>
    })

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [id])


    return (
        <>
            <CommonLayout backgroundColor={'white'}>
                <div className="detail-product-container">
                    <div className='navigation' onClick={() => navigate(-1)}>← Повернутись до каталогу</div>
                    <div className="product-block">
                        <div className="product-image">
                            <div className="product-image-wrapper">
                                <div className="arrow-wrapper" onClick={previousImage} style={{ display: typeof (product.urlImg) == typeof ([]) ? "" : "none" }}>
                                    <Icon iconUrl={"/icons/arrow-left.svg"} width={"40px"} height={"40px"}></Icon>
                                </div>
                                <img src={typeof (product.urlImg) == typeof ([]) ? product.urlImg[imageCount] : product.urlImg}></img>
                                <div className="arrow-wrapper right" onClick={nextImage} style={{ display: typeof (product.urlImg) == typeof ([]) ? "" : "none" }}>
                                    <Icon iconUrl={"/icons/arrow-left.svg"} width={"40px"} height={"40px"}></Icon>
                                </div>
                            </div>
                            <div className="contact-phone-block">
                                <h4>+380970230023</h4>
                                <div className="sub-text-contact">Менеджер замовлень</div>
                            </div>
                        </div>
                        <div className="product-detail">
                            <p>Артикул: {product.code}</p>
                            <div className="price">Ціна: {product.price}{initializePrice(product)}</div>
                            <div className="instock">В наявності</div>
                            {product.sizes != null ?
                                <div className="sizes">
                                    Оберіть розмір:
                                    <div className="sizes-wrapper">{renderSizes()}</div>
                                </div> : null}
                            <div className="buttons-group">
                                <div class="add-to-cart" onClick={AddProductToCart}>
                                    <PrimaryButton width={"300px"} height={"50px"} text={'Додати в кошик'}></PrimaryButton>
                                </div>
                                <div class="to-cart" onClick={() => navigate('/order-confirm')}>
                                    <PrimaryButton width={"300px"} height={"50px"} text={'Перейти в кошик'}></PrimaryButton>
                                </div>
                                <div class="order-now" onClick={() => setModalOpen(true)}>
                                    <PrimaryButton width={"300px"} height={"50px"} text={'Замовити в 1 клік'}></PrimaryButton>
                                </div>
                            </div>
                            <div className="desc">
                                <div className="desc-value-text">
                                    <div className="choose-text-field">
                                        <div className={`choose-text-value ${textField == 0 ? 'active' : ''}`} onClick={() => setTextField(0)}>Опис</div>
                                        <div className={`choose-text-value ${textField == 1 ? 'active' : ''}`} onClick={() => setTextField(1)}>Характеристики</div>


                                    </div>
                                    <div className="choose-text-field">
                                        <div className={`choose-text-value ${textField == 2 ? 'active' : ''}`} onClick={() => setTextField(2)}>Доставка</div>

                                        <div className={`choose-text-value ${textField == 3 ? 'active' : ''}`} onClick={() => setTextField(3)}>Оплата</div>
                                        <div className={`choose-text-value ${textField == 4 ? 'active' : ''}`} onClick={() => setTextField(4)}>Гарантія і повернення</div>
                                    </div>
                                    <div className={`text-value ${textField == 0 ? 'active' : ''}`}>{product.desc}</div>
                                    <div className={`text-value ${textField == 1 ? 'active' : ''}`}>{product.char}</div>
                                    <div className={`text-value ${textField == 2 ? 'active' : ''}`}>

                                        Безкоштовно - від 1 200 грн<br />
                                        Наложений платіж, відправка пн-пт<br />
                                        <br />
                                        Безкоштовно - від 2 000 грн<br />
                                        Наложений платіж, відправка щодня<br />
                                        <br />
                                        Доставка по м. Житомир - 50грн<br />
                                        Уточнюйте в менеджера<br />
                                    </div>
                                    <div className={`text-value ${textField == 3 ? 'active' : ''}`}>
                                        На вибір: <br />
                                        -Оплата при отриманні на пошті, без передоплат.<br />
                                        -Оплата на карту.<br />
                                        -Оплата на рахунок ФОП. Ви отримуєте смс з чеком на свій телефон.
                                    </div>
                                    <div className={`text-value ${textField == 4 ? 'active' : ''}`}>
                                        Якщо товар неналежної якості (що стається дуже рідко). Можливе повернення та обмін.<br />
                                        <br />
                                        При замовленні товару ви перевіряєте товар, якщо все підходить - ви забираєте товар.<br />
                                        <br />
                                        Якщо вам не підходить розмір або щось інше, ви можете зателефонувати нам та ми зробимо обмін чи повернення.
                                        0970230023
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="addition-block">
                        <h4>З цим товаром також замовляють:</h4>
                        <div className="addition-block-wrapper">
                            {salesAdditionProduct}
                        </div>
                    </div>
                    <div className="sale-block">
                        <h4>Схожі шкарпетки:</h4>
                        <div className="sale-block-wrapper">
                            {salesProduct}
                        </div>
                    </div>
                </div>
                <ModalOrderWindow modalOpen={modalOpen} closeModal={closeModal} productName={product.code} />
                <Snackbar
                    open={isShowNotification}
                    autoHideDuration={2000}
                    onClose={() => setIsShowNotification(false)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                >
                    <Alert
                        onClose={() => setIsShowNotification(false)}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        Товар додано до кошика
                    </Alert>
                </Snackbar>
            </CommonLayout>
        </>
    )
}

export default DetailProduct;